import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-5 py-14 md:py-24" data-id="element-69" data-mp="1nv1jw8a1vxxt">
      <Reveal className="mx-auto max-w-3xl" data-id="element-70" data-mp="2bk40rdwv1mr9">
        <SectionHeading eyebrow="Good to know" title="Frequently Asked Questions" data-id="element-71" data-mp="2bmgrafgop5fx" />
        <div className="mt-12 space-y-3" data-id="element-72" data-mp="2fns5zpy0s69c">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.question} className="overflow-hidden rounded-card border border-tr-border bg-white" data-id="element-73" data-mp="26rav8ntkiae4" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-[15px] font-semibold text-tr-navy transition-colors duration-150 ease-out hover:bg-tr-cream/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-tr-orange" data-id="element-74" data-mp="2zaq4iszu0kvg">
                  <span data-id="element-75" data-mp="2ffv1dn8rkj7x">{faq.question}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-tr-grey transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-76" data-mp="2af726eadsw2m" />
                </button>
                <AnimatePresence initial={false} data-id="element-77" data-mp="2jd96b2pew4u4">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-78" data-mp="u0xku44k47la">
                      <p className="px-6 pb-6 text-[15px] leading-relaxed text-tr-grey" data-id="element-79" data-mp="2z0ozv72e256y">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}